<template>
  <div>
    <div class="seachBox flex">
      <div class="seachList">
        <span class="name">删除日期：</span>
        <a-range-picker @keydown.enter.native="searchKey" class="seachs" v-model="seach.delete_time" :allowClear="false"
                        :showTime="false"
                        format="YYYY-MM-DD"/>
      </div>
      <div class="seachList">
        <span class="name">颜色：</span>
        <a-select v-model="seach.a_template_color_id" class="seachs" allowClear @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.color_list">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList">
        <span class="name">行业：</span>
        <a-select v-model="seach.a_ksh_industry_id" class="seachs" allowClear @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.industry_list">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList"><span class="name">编号：</span>
        <a-input placeholder=" " class="seachs" v-model="seach.code" @keydown.enter.native="searchKey"/>
      </div>
      <div class="seachList"><span class="name">模板类型：</span>
        <a-select v-model="seach.type" class="seachs" allowClear @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.type_list">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList"><span class="name">设计师：</span>
        <a-select v-model="seach.designer_id" class="seachs" allowClear @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.designer_list">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachBtnBox">
        <a-button type="primary" class="seachBtn" @click="getList(1)"> 查询</a-button>
        <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
      </div>
    </div>
    <a-button class="top_btn" type="primary" @click="handleRecovery()">
      恢复
    </a-button>
    <a-button class="top_btn" type="primary" @click="handleDelete()"> 删除 </a-button>

    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
             :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :scroll="{ x: 1300 }">
      <span slot="thumb" slot-scope="text, record">
         <img src="../../../assets/tem2.png" alt="" @click="()=>{visibleImg=true;tableImg=record.picture}"
              style="width:30px;display: block;cursor: pointer">
      </span>
      <span slot="action" slot-scope="text, record">
            <a @click="handleRecovery(record)">恢复<a-divider type="vertical"/></a>
            <a @click="handleDelete(record)">删除</a>
      </span>
    </a-table>
    <a-modal :footer="null"
             title="查看大图"
             :visible="visibleImg"
             @cancel="()=>{visibleImg=false}"
    >
      <img :src="tableImg" alt="" style="width: 100%;display: block">
    </a-modal>
  </div>
</template>

<script>
import API from "./api";
import moment from 'moment';
import { removeById } from "@/utils/utils"
import templateRecycleColumns from "./config/templateRecycleColumns"
import handle from "ant-design-vue/lib/vc-slider/src/Handle";
// 移除未使用的导入

export default {
  name: "index",
  data() {
    return {
      selectedRowKeys: [],
      urlBase: this.$store.state.urlExper,
      resetSeachdata: true,
      visibleImg: false,
      tableImg: "",
      seach: {
        delete_time: [],
        a_template_color_id: undefined,
        a_ksh_industry_id: undefined,
        code: '',
        type: undefined,
        designer_id: undefined
      },
      seachList: {
        industry_list: [],
        color_list: [],
        designer_list: [],
        type_list: []
      },
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      loading: true,
      columns: templateRecycleColumns
    }
  },
  computed: {
    handle() {
      return handle
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/ksh/KshTemplateRecycle"; //设置左侧导航2-2 active
  },
  mounted() {
    this.getList()
  },
  components: {},
  methods: {
    searchKey() {
      if (event && event.keyCode === 13) {
        this.getList(1)
      }
    },
    resetSeach() {
      this.loading = true
      this.seach = {
        delete_time: [],
        a_template_color_id: undefined,
        a_ksh_industry_id: undefined,
        code: '',
        type: undefined,
        designer_id: undefined
      }
      this.resetSeachdata = false
      this.getList(1)
    },
    getList(page) {
      let seachData = JSON.parse(JSON.stringify(this.seach))
      if (seachData.delete_time.length > 0 && this.resetSeachdata) {
        seachData.delete_time[0] = moment(this.seach.delete_time[0]).format('YYYY-MM-DD')
        seachData.delete_time[1] = moment(this.seach.delete_time[1]).format('YYYY-MM-DD')
      } else {
        seachData.delete_time = []
      }
      API.service.TEMPLATE_RECYCLIE_LIST({page: page || 1, ...seachData}).then(res => {
        this.data = res.data.data.list.data
        this.seachList.industry_list = res.data.data.industry_list
        this.seachList.color_list = res.data.data.color_list
        this.seachList.designer_list = res.data.data.designer_list
        this.seachList.type_list = res.data.data.type_list

        this.pagination.total = res.data.data.list.total
        this.pagination.pageSize = res.data.data.list.per_page
        this.pagination.current = res.data.data.list.current_page
        if (!this.resetSeachdata) this.seach.update_time = []
        this.resetSeachdata = true
        this.loading = false
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleRecovery(row) {
      let _this = this
      let ids = []
      if(row) {
        ids = [row.id]
      } else {
        ids = _this.selectedRowKeys
      }
      if(ids.length < 1) {
        _this.$message.destroy()
        _this.$message.warning('请选择要恢复的模版')
        return false
      }
      _this.$confirm({
        content: "确认恢复该模板吗？",
        icon: "exclamation-circle",
        type: 'warning',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          API.service.TEMPLATE_RECYCLIE_RECOVERY({ids: ids}).then(res => {
              if(res.data.code == 200) {
                _this.$message.success(res.data.msg)
                _this.getList(_this.pagination.current)
              }
          })
        },
        onCancel() {}
      });
    },
    handleDelete(row) {
      let _this = this
      let ids = []
      if(row) {
        ids = [row.id]
      } else {
        ids = _this.selectedRowKeys
      }
      if(ids.length < 1) {
        _this.$message.destroy()
        _this.$message.warning('请选择要删除的模版')
        return false
      }
      _this.$confirm({
        content: "此操作将永久删除, 是否继续?",
        icon: "exclamation-circle",
        type: 'warning',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          removeById(API.service.DELE, ids).then(res => {
            if (res == true) {
              _this.getList()
            }
          })
        },
        onCancel() {}
      });

    }
  }
}
</script>

<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}

.seachBox .seachBtnBox {
  position: static;
  margin-top: 0;
  text-align: right;
  padding-right: 10px;
}
</style>